import React from "react";
import * as Mui from "@mui/material";
import { useHistory } from "react-router-dom";
import { ArrowForward, SettingsOutlined } from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";
import { designColors, designRadii, designShell } from "services/constants/designTokens";
import {
  findSettingsItem,
  settingsItemHref,
} from "pages/PayRoll/Configuration/payrollSettingsMenu";

// Switch between a day-to-day Payroll screen (e.g. Pay Inputs > Overtime)
// and its Payroll Settings page, both ways:
//   <OpenSettingsButton group="pay-input" item="overtime" />  on the screen
//   <OpenDailyScreenButton group="pay-input" item="overtime" /> on settings
// group / item are the keys in payrollSettingsMenu.js.

// Square ⚙ button, the same height as the screen's main action button.
export const OpenSettingsButton = ({ group, item, sx = {} }) => {
  const history = useHistory();
  const setting = findSettingsItem(group, item);
  if (!setting) return null;
  const label = `${setting.label} settings`;
  return (
    <Mui.Tooltip title={label} arrow slotProps={tooltipStyleProps}>
      <Mui.IconButton
        aria-label={label}
        onClick={() => history.push(settingsItemHref(setting))}
        sx={{
          width: 46,
          height: 46,
          flexShrink: 0,
          border: `1px solid ${designColors.slate300}`,
          borderRadius: designRadii.control,
          backgroundColor: designColors.white,
          color: designColors.slate700,
          "&:hover": {
            backgroundColor: designColors.slateBg,
            borderColor: designColors.slate400,
            color: designColors.tealDark,
          },
          ...sx,
        }}
      >
        <SettingsOutlined fontSize="small" />
      </Mui.IconButton>
    </Mui.Tooltip>
  );
};

// "View Overtime →" on a settings page, back to its day-to-day screen.
export const OpenDailyScreenButton = ({ group, item, sx = {} }) => {
  const history = useHistory();
  const setting = findSettingsItem(group, item);
  if (!setting?.dailyPath) return null;
  return (
    <Mui.Button
      variant="outlined"
      endIcon={<ArrowForward fontSize="small" />}
      onClick={() => history.push(setting.dailyPath)}
      sx={{ ...designShell.panelNeutralButton, px: 2, whiteSpace: "nowrap", flexShrink: 0, ...sx }}
    >
      View {setting.dailyLabel}
    </Mui.Button>
  );
};
